import { getWindow } from './browserVars';

const browserWindow = getWindow();
const makeVideoLive = (videoElem) => {
  Array.from(videoElem.children).forEach((item) => {
    const videoSource = item;
    if (
      typeof videoSource.tagName === 'string'
          && videoSource.tagName === 'SOURCE'
    ) {
      videoSource.src = videoSource.dataset.src;
    }
  });
  videoElem.load();
  videoElem.classList.remove('lazy');
  videoElem.classList.add('playing');
  videoElem.setAttribute('controls', 'true');
};

const processEmbeddedVideoElems = (videoElem) => {
  if ('IntersectionObserver' in browserWindow) {
    const lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((observerEvent) => {
        if (observerEvent.isIntersecting) {
          makeVideoLive(observerEvent.target);
          lazyVideoObserver.unobserve(videoElem);
        }
      });
    });

    lazyVideoObserver.observe(videoElem);
  } else {
    makeVideoLive(videoElem);
  }
};

const addLazyVideoLoading = async (rootElement) => {
  if (rootElement && browserWindow) {
    const lazyVideos = Array.from(rootElement.querySelectorAll('video.lazy'));
    lazyVideos.forEach((vidElem) => { processEmbeddedVideoElems(vidElem); });
  }
};

export default addLazyVideoLoading;
